<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo main__logo__title">
        <img src="../../assets/images/logo/logo.svg" alt="">
        <h2 class="brand-text ml-1 title">
          Enterprise<br>
          <span class="title_go">GoDigital</span>
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img fluid :src="imgUrl" alt="Reset Password" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Reset Password-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="mb-1">
            Reset Password 🔑
          </b-card-title>
          <b-card-text class="mb-2">
            Create a new password for your account.
          </b-card-text>

          <!-- form -->
          <b-form class="auth-reset-password-form mt-2" @submit.prevent="resetPassword">
            <b-form-group label="New Password" label-for="reset-password-new">
              <b-input-group class="input-group-merge">
                <b-form-input id="reset-password-new" v-model="newPassword" :type="passwordFieldType"
                  name="reset-password-new" placeholder="Enter new password" />
                <b-input-group-append is-text>
                  <feather-icon :icon="newPasswordToggleIcon" class="cursor-pointer"
                    @click="toggleNewPasswordVisibility" />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

            <b-form-group label="Confirm New Password" label-for="reset-password-confirm">
              <b-input-group class="input-group-merge">
                <b-form-input id="reset-password-confirm" v-model="confirmPassword" :type="confirmPasswordFieldType"
                  name="reset-password-confirm" placeholder="Confirm new password" />
                <b-input-group-append is-text>
                  <feather-icon :icon="confirmPasswordToggleIcon" class="cursor-pointer"
                    @click="toggleConfirmPasswordVisibility" />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

            <b-button type="submit" variant="primary" block>
              Reset Password
            </b-button>
          </b-form>

          <p class="text-center mt-2">
            <b-link :to="{ name: 'auth-login' }">
              <feather-icon icon="ChevronLeftIcon" /> Back to login
            </b-link>
          </p>
        </b-col>
      </b-col>
      <!-- /Reset Password-->
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BLink, BCardTitle, BCardText, BImg, BForm, BFormGroup, BFormInput, BButton, BInputGroup, BInputGroupAppend } from 'bootstrap-vue'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BImg,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BCardTitle,
    BCardText,
    BInputGroup,
    BInputGroupAppend
  },
  data() {
    return {
      newPassword: '',
      confirmPassword: '',
      passwordFieldType: 'password',
      confirmPasswordFieldType: 'password',
      sideImg: require('@/assets/images/pages/reset-password-v2.svg'),
    }
  },
  methods: {
    toggleNewPasswordVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
    },
    toggleConfirmPasswordVisibility() {
      this.confirmPasswordFieldType = this.confirmPasswordFieldType === 'password' ? 'text' : 'password';
    },
    resetPassword() {
      // Perform password reset logic here
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Your password has been reset successfully',
          icon: 'EditIcon',
          variant: 'success',
        },
      })
    },
  },
  computed: {
    newPasswordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon';
    },
    confirmPasswordToggleIcon() {
      return this.confirmPasswordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon';
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        this.sideImg = require('@/assets/images/pages/reset-password-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.main__logo__title .title {
  color: #4065ab;
  font-weight: 700;
}

.main__logo__title .title_go {
  color: #b0cc48;
  font-weight: 700;
}

.main__logo__title img {
  width: 60px;
  height: auto;
}
</style>
